// extracted by mini-css-extract-plugin
module.exports = {"page":"index-module--page--2hJ7Y","visitLink":"index-module--visitLink--3nzZb"};